import script from "./ImageCarouselEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCarouselEditor.vue?vue&type=script&setup=true&lang=js"

import "./ImageCarouselEditor.vue?vue&type=style&index=0&id=752f1d94&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752f1d94"]])

export default __exports__